import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=09a11c55&scoped=true&"
var script = {}
import style0 from "./Donation.vue?vue&type=style&index=0&id=09a11c55&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a11c55",
  null
  
)

export default component.exports